var swiper3El = document.querySelector(".iwt-slider");
Object.assign(swiper3El, {
  grabCursor: false,
  effect: "creative",
  slidesPerView: 1,
  pagination: {
    el: '.slider__pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.right-arrow',
    prevEl: '.left-arrow',
  },
  creativeEffect: {
    prev: {
      shadow: true,
      translate: ["-100%", 0, 0]
    },
    next: {
      translate: ["100%", 0, 0]
    }
  }
});
swiper3El.initialize();